module.exports = __webpack_public_path__ + "images/category_lp/trading_card/store_images/1_339de7f0f6bcc9c160417439907f6600.png";